import { StoreEntity } from './store.type';

export enum ArticleStatus {
  ENABLE = 'enable',
  DISABLE = 'disable',
}

export enum ArticleType {
  FAQ = 'faq',
  NOTICE = 'notice',
  EVENT = 'event',
  STORY = 'story',
  BLOG = 'blog',
  LICENSE_PROCESS = 'license_process',
  TEST_COURSE_ANALYSIS = 'test_course_analysis',
  TEST_COURSE_ROAD_ANALYSIS = 'test_course_road_analysis',
  TEST_COURSE_SKILL_ANALYSIS = 'test_course_skill_analysis',
}

export interface ArticleUpfileEntity {
  id: number;
  articleId: number;
  upfileId: number;
  status: ArticleStatus;
  registerDatetime: string;
  disableDatetime: string;
}

export interface BoardEntity {
  id: number;
  type: ArticleType;
  name: string;
  registerDatetime: string;
}

export interface BaseArticleEntity {
  id: number;
  title: string;
  viewDatetime: string;
}

export interface ArticleEntity extends BaseArticleEntity {
  boardId: number;
  storeId: number;
  thumbUpfileId: number;
  mainBannerUpfileId: number;
  author: string;
  content: string;
  status: ArticleStatus;
  numRead: number;
  point: number;
  registerDatetime: string;
  modifyDatetime: string;
  readDatetime: string;
  isTop: boolean;
  classType: string;
  startDatetime: string;
  endDatetime: string;
  subTitle: string;
  keywords: string;
  iconBcolor: string;
  iconFcolor: string;
  iconText: string;
  board: BoardEntity;
  upfiles: ArticleUpfileEntity[];
  thumbUpfile: string;
  thumbPath: string;
  mainBannerUpfile: string;
  mainBannerPath: string;
  store?: StoreEntity;
  previous?: BaseArticleEntity;
  next?: BaseArticleEntity;
  // 연결된 시험장(academy) ID. 코스분석 글 상세에서만 채워지며, 없으면 null.
  academyId?: number | null;
}

export interface GetArticleListParams {
  page?: number;
  limit?: number;
  type?: ArticleType;
  category?: string;
  academyId?: number;
}

export interface ArticleListResponse {
  totalCount: number;
  limit: number;
  articles: ArticleEntity[];
}

export interface ArticleListProps {
  items: ArticleEntity[];
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
